import LoginScreen from "./LoginScreen";
import MainContainer from "./MainContainer";
import { utils } from "vincent-utils";
import { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { LoggedUserAtom } from "../state/globalState.ts";
import poster from "../../../utils/poster.ts";
import type { UserLimited } from "cadendar-shared";
import { buildUpdateController } from "./buildUpdate";

const devHost = import.meta.env.VITE_DEV_HOST || "";
const prefix = "cadendarRest";
const cleanedUrl = "getConnectedUserByCookie";
const getUser = async (): Promise<UserLimited> => {
  const finalUrl = `${devHost ? devHost + "/" : "/"}${prefix}/${cleanedUrl}`;
  const response = await fetch(finalUrl, {
    mode: "cors",
    credentials: "include",
  });
  buildUpdateController.reportServerBuild(response.headers.get("x-build-number"));
  if (response.ok) {
    const text = await response.text();
    return JSON.parse(text, utils.jsonDateReviver);
  } else {
    throw new Error(`invalide json dans fetch ${prefix}/${cleanedUrl}`);
  }
};

const LoginSwitcher = () => {
  const [user, setUser] = useAtom(LoggedUserAtom);
  console.log("user", user);
  const [shouldFetch, setShouldFetch] = useState(true);

  useEffect(() => {
    if (user) {
      buildUpdateController.setUpdateMode("confirm");
      return;
    }

    buildUpdateController.setUpdateMode(shouldFetch ? "confirm" : "auto");
  }, [shouldFetch, user]);

  useEffect(() => {
    if (!shouldFetch) {
      return;
    }
    setShouldFetch(false);
    getUser().then((user) => {
      setUser(user);
      if (user) {
        // LogRocket.identify(user.id, {
        //   name: user.messagename,
        // });
      }
    });
  }, [shouldFetch]);
  const loginCallBack = () => {
    setShouldFetch(true);
  };
  const logoutCallBack = () => {
    poster(`${prefix}/logout`, {}).then(() => {
      setShouldFetch(true);
    });
  };
  if (user) {
    return <MainContainer user={user} />;
  } else {
    return <LoginScreen callBack={loginCallBack} />;
  }
};

export default LoginSwitcher;
